import PropTypes from 'prop-types';
import React from 'react';
import floor from 'lodash/floor';
import isEmpty from 'lodash/isEmpty';
import isFinite from 'lodash/isFinite';
import Spinner from '../../../customers/customersList/spinner';

import FormatNumber from './FormatNumber';

const priceShorthandThreshold = 10000 * 100; // 10,000.00 in cents

const AnalyticsBlock = ({ title, data, format, isFetching, automationIdBase }) => {
  if (isEmpty(data)) return null;

  const { first } = data;
  const { second } = data;
  const difference = floor(((first - second) / second) * 100, 1);
  const differenceClassName = (() => {
    if (difference > 0) return 'u-co-green';
    if (difference < 0) return 'u-co-red';
    return 'u-co-gray';
  })();

  return (
    <div className="c-analytics-block">
      <div className="c-analytics-block__label">
        { title }
      </div>
      <div className="c-analytics-block__body">
        <div className="u-1/1" display-if={isFetching}>
          <Spinner className="u-margin-auto" size="small" />
        </div>
        <div className="u-co-primary" display-if={!isFetching}>
          <FormatNumber
            format={format}
            bigPriceThreshold={priceShorthandThreshold}
            automationId={`text:${automationIdBase}:first`}
          >
            {first}
          </FormatNumber>
        </div>
        <div
          className={differenceClassName}
          display-if={!isFetching && isFinite(difference)}
          data-automation-id={`text:${automationIdBase}:difference`}
        >
          {difference > 0 ? '+' : ''}
          {isFinite(difference) ? Math.round(difference) : 0}%
        </div>
        <div className="u-co-blue" display-if={!isFetching && isFinite(second)}>
          <FormatNumber
            format={format}
            bigPriceThreshold={priceShorthandThreshold}
            automationId={`text:${automationIdBase}:second`}
          >
            {second}
          </FormatNumber>
        </div>
      </div>
    </div>
  );
};
AnalyticsBlock.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    first: PropTypes.number,
    second: PropTypes.number,
  }),
  format: PropTypes.string,
  isFetching: PropTypes.bool.isRequired,
  automationIdBase: PropTypes.string,
};
AnalyticsBlock.defaultProps = {
  format: '',
  data: null,
  automationIdBase: null,
};

export default AnalyticsBlock;
